const NAV_WIDTH = 80

const styles = theme => ({
  root: {
    width: '100%',
    maxWidth: 760,
    margin: '0 auto',
    // Room for the fixed footer.
    padding: '28px 24px 96px',
    fontFamily: "'Inter', system-ui, sans-serif",
    color: '#002E47',
    [theme.breakpoints.down('xs')]: {
      padding: '20px 12px 120px',
    },
  },
  body: {
    display: 'flex',
    flexDirection: 'column',
    gap: 14,
  },
  back: {
    alignSelf: 'flex-start',
    display: 'inline-flex',
    alignItems: 'center',
    gap: 4,
    padding: 0,
    border: 0,
    background: 'transparent',
    cursor: 'pointer',
    fontFamily: 'inherit',
    fontSize: '13px',
    fontWeight: 500,
    color: '#015FFB',
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    gap: 14,
    margin: '8px 0 10px',
  },
  headerIcon: {
    width: 44,
    height: 44,
    flex: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '12px',
    background: '#E9F1FF',
    color: '#015FFB',
  },
  title: {
    fontSize: '24px',
    fontWeight: 700,
    letterSpacing: '-.01em',
    color: '#002E47',
  },
  subtitle: {
    marginTop: 2,
    fontSize: '14px',
    color: '#637381',
  },
  courseInfo: {},
  // Fixed to the viewport next to the side nav (sticky does not work under
  // the global `body { display: inline }`).
  footer: {
    position: 'fixed',
    right: 0,
    bottom: 0,
    left: NAV_WIDTH,
    zIndex: 10,
    padding: '14px 24px',
    borderTop: '1px solid #E5E7EB',
    background: '#fff',
    [theme.breakpoints.down('sm')]: {
      left: 0,
    },
  },
  footerInner: {
    maxWidth: 712,
    margin: '0 auto',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: 12,
  },
  credits: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 6,
    fontSize: '12px',
    color: '#637381',
  },
  footerActions: {
    display: 'flex',
    gap: 8,
  },
  footerBack: {
    padding: '9px 14px',
    border: 0,
    borderRadius: '8px',
    background: 'transparent',
    cursor: 'pointer',
    fontFamily: 'inherit',
    fontSize: '13px',
    fontWeight: 500,
    color: '#637381',
  },
  start: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 6,
    padding: '9px 18px',
    border: 0,
    borderRadius: '8px',
    fontFamily: 'inherit',
    fontSize: '13px',
    fontWeight: 600,
    color: '#fff',
  },
  loadingContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '400px',
  },
  outlineErrorContainer: {
    marginTop: theme.spacing(2),
    padding: theme.spacing(2),
    backgroundColor: theme.palette.error.light,
    borderRadius: theme.shape.borderRadius,
  },
  outlineError: {
    color: theme.palette.error.contrastText,
    textAlign: 'center',
  },
})

export default styles
